import { CasesService } from "../../../../share/services/cases";
export interface IUploadMiscImageSettings {
    caseId: string;
    imageId: string;
    base64: string;
    retry: number;
}
export class UploadMiscImages {
    constructor(public setValue, public newCase, public getState) {

    }
    public async uploadMiscellaneous() {
        this.setValue({ loadingMessage: 'Uploading and Procesing Miscellaneous', caseSaved: true })
        return Promise.all([this.uploadMiscellaneousImages()]);
    }
    public uploadMiscellaneousImages() {
        const { caseId, agencyCode } = this.newCase;
        const miscImages: string[] = this.newCase.miscellaneous;
        const promises: any[] = [];
        miscImages.forEach((image, imageId) => {
            promises.push(this.uploadMiscellaneousImage({
                caseId: `${agencyCode}-${caseId}`, imageId: imageId + "", base64: image, retry: 0
            }));
        });
        return Promise.all(promises);
    }
    public uploadMiscellaneousImage(settings: IUploadMiscImageSettings) {
        const { caseId, imageId, base64 } = settings
        const imageKey = `${settings.imageId}`
        return this.ifWasNotUploadMisc(imageKey, () => {
            return Promise.resolve()
                .then(() => this.setImageState(imageKey, "UPLOADING"))
                .then(() => CasesService.uploadMiscImage({ caseId, imageId: imageId + "", image: base64 }))
                .then((success) => this.manageResponseMisc(success, settings, imageKey))
        })
    }
    public removeMiscellaneousImages(imagesToRemove: string[]) {
        const { caseId, agencyCode } = this.newCase;
        const caseIdBuild = `${agencyCode}-${caseId}`;
        const promises: any[] = [];
        imagesToRemove.forEach((image) => {
            promises.push(this.removeMiscellaneousImage(caseIdBuild, image))
        });
        return Promise.all(promises);
    }
    public removeMiscellaneousImage(caseId: string, image: string) {
        return Promise.resolve()
            .then(() => CasesService.removeMiscImage(caseId, image))
    }
    private manageResponseMisc(success: boolean, settings: IUploadMiscImageSettings, imageKey: string) {
        if (success) {
            return this.setImageState(imageKey, "SUCCESS")
        } else {
            settings.retry++;
            return settings.retry > 2 ?
                this.setImageState(imageKey, "FAILED") :
                new Promise(resolve => setTimeout(() => resolve(this.uploadMiscellaneousImage(settings)), 500))
        }
    }
    public ifWasNotUploadMisc(id, fn: () => Promise<any>) {
        return new Promise((resolve) => this.wasImageUploadedMisc(id) ? resolve() : resolve(fn()))
    }
    public wasImageUploadedMisc(id: string) {
        const status = this.getState().imageUploadingStatus;
        const image = this.getState().caseInfo.miscellaneous[id];
        return status && status[id] && status[id].status === 'SUCCESS' || image.includes('https') || image === "";
    }
    public getErrorsUploadingImage() {
        const ius = this.getState().imageUploadingStatus;
        return Object.keys(ius).filter((key) => ius[key].status === "FAILED")
    }
    public wasErrorsUploadingImages() {
        return this.getErrorsUploadingImage().length > 0
    }
    public setImageState(id, imageState: 'UPLOADING' | 'SUCCESS' | 'FAILED') {
        return this.ifWasNotUploadMisc(id, () => this.setValue(`imageUploadingStatus[${id}]`, { status: imageState }))
    }
}


// WEBPACK FOOTER //
// ./src/modules/Case/Add/helpers/uploadMiscellaneous.ts